import React from 'react';
import styles from '../Styles/Campaigns.module.css';
import { fmtCT } from './time';

// SCRUM-449: the dry-run impact of a playbook save — which active events'
// unsent steps change — shown before Confirm. Times are Central, labelled CT.

/** Occurrence id `<campaignId>:<slotId>:<local date>` → its date. */
const occDate = (id) => String(id).split(':').pop();

const WHAT_LABEL = { text: 'new text', time: 'new time', added: 'added', removed: 'removed' };

export default function ImpactModal({ impact, busy, invalid, onConfirm, onCancel }) {
  return (
    <div className={styles.overlay}>
      <div className={styles.modal} role="dialog" aria-modal="true" aria-labelledby="impact-title">
        <h3 id="impact-title" className={styles.modalTitle}>Before you save</h3>
        {impact.length === 0 ? (
          <p className={styles.muted}>No active events affected.</p>
        ) : (
          <div className={styles.impactList}>
            <p className={styles.muted}>
              Unsent steps on these active events change. Sent steps never change.
            </p>
            {impact.map((ev) => (
              <div key={ev.eventId} className={styles.impactEvent}>
                <strong>{ev.eventName}</strong>
                {ev.changed?.length > 0 && (
                  <ul>
                    {ev.changed.map((c) => (
                      <li key={c.occurrenceId}>
                        {c.name} · {fmtCT(c.dueAt)} — {(c.what ?? []).map((w) => WHAT_LABEL[w] ?? w).join(', ')}
                      </li>
                    ))}
                  </ul>
                )}
                {ev.overridden?.length > 0 && (
                  <div className={styles.impactNote}>
                    Overridden on this event, keeps its own edit: {ev.overridden.map(occDate).join(', ')}
                  </div>
                )}
                {ev.intoPast?.length > 0 && (
                  <div className={styles.impactWarn}>
                    Moves into the past: {ev.intoPast.map(occDate).join(', ')} — sends right away if less than an hour
                    late, otherwise recorded as missed.
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
        <div className={styles.modalActions}>
          <button type="button" className={styles.secondaryBtn} onClick={onCancel} disabled={busy}>Cancel</button>
          <button type="button" className={styles.primaryBtn} onClick={onConfirm} disabled={busy || invalid} autoFocus>
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
}
